<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" max-width="600" scrollable persistent>
			<v-card>
				<v-card-title class="text-h6">Ubah Alamat Pelanggan</v-card-title>
				<v-card-text>
					<v-form ref="formAddress" role="form">
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense v-model="provinsi" :rules="provinceRules"
									@focus="() => responseError.province_id = ''" :error-messages="responseError.province_id" :items="provinces"
									label="Provinsi" item-text="province" item-value="province_id" @change="getCity"
									no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense v-model="kota" :rules="cityRules" @focus="() => responseError.city_id = ''"
									:error-messages="responseError.city_id" :items="cities" label="Kota/Kabupaten" @change="getSubdistrict"
									:item-text="item => item.type + ' ' + item.city_name" item-value="city_id"
									no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense @change="cekMaps" :rules="subdistrictRules"
									@focus="() => responseError.subdistrict_id = ''" :error-messages="responseError.subdistrict_id"
									v-model="kecamatan" :items="subdistricts" item-text="subdistrict_name" item-value="subdistrict_id"
									label="Kecamatan" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-textarea outlined dense @change="cekMaps" :rules="addressRules" @focus="() => responseError.address = ''"
									:error-messages="responseError.address" v-model="address" label="Alamat Lengkap" no-resize
									height="190"></v-textarea>
							</v-col>
							<v-col cols="6" class="pb-0">
								<v-text-field outlined dense hide-details label="Latitude" :value="formLocation.lat"
									@input="updateLat"></v-text-field>
							</v-col>
							<v-col cols="6" class="pb-0">
								<v-text-field outlined dense hide-details label="Longitude" :value="formLocation.lng"
									@input="updateLng"></v-text-field>
							</v-col>
							<v-col cols="12" class="pb-0" v-if="true">
								<!-- <GmapMap :center="{ lat: location.lat, lng: location.lng}" :zoom="16" :options="mapOptions" map-type-id="roadmap" style="width: 100%; height: 100%" >
										<GmapMarker ref="myMarker" :position="{ lat: location.lat, lng: location.lng}" :draggable="true" @dragend="updateCoordinates"></GmapMarker>
									</GmapMap>
									-->
								<div style="width: 100%; height: 300px;">
									<l-map v-resize="onResize" :zoom="zoom" :center="center" ref="myMap">
										<l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
										<l-marker :lat-lng="position" :draggable="draggable" @dragend="updateLocation" :z-index-offset="1000">
										</l-marker>
										<l-marker v-if="storeLocation.lat !== 0 &&storeLocation.lng !== 0" :lat-lng="storePosition" :icon="customIcon">
										</l-marker>
										<v-geosearch :options="geosearchOptions"></v-geosearch>
									</l-map>
								</div>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import VGeosearch from 'vue2-leaflet-geosearch';
import { mapActions, mapState } from 'vuex'
import { LMap, LMarker, LTileLayer } from 'vue2-leaflet';
import { latLng, icon } from 'leaflet';
import { OpenStreetMapProvider } from 'leaflet-geosearch';

export default {
	components: {
		LMap,
		LTileLayer,
		LMarker,
		VGeosearch
	},
	data() {
		return {
			dialog: false,
			params: [],
			provinsi: '',
			kota: '',
			kecamatan: '',
			address: '',
			storeLocation: {
				lat: 0,
				lng: 0,
			},
			location: {
				lat: -6.195590285033856,
				lng: 106.8240061190492
			},
			formLocation: {
				lat: '',
				lng: ''
			},
			provinceRules: [
				value => !!value || 'Provinsi tidak boleh kosong',
			],
			cityRules: [
				value => !!value || 'Kota tidak boleh kosong',
			],
			subdistrictRules: [
				value => !!value || 'Kecamatan tidak boleh kosong',
			],
			addressRules: [
				value => !!value || 'Alamat Lengkap tidak boleh kosong',
			],
			// mapOptions: {
			// 	zoomControl: true,
			// 	mapTypeControl: false,
			// 	scaleControl: false,
			// 	streetViewControl: false,
			// 	rotateControl: false,
			// 	fullscreenControl: false,
			// 	disableDefaultUi: true
			// },
			provinces: [],
			cities: [],
			subdistricts: [],

			url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
			attribution:
				'',
			zoom: 14,
			draggable: true,
			customIcon: icon({
				iconUrl: '/assets/icon/store-marker.png', // Path relative to your public directory
				iconSize: [50, 56], // size of the icon
				iconAnchor: [25, 56], // point of the icon which will correspond to marker's location
			}),
			geosearchOptions: {
				provider: new OpenStreetMapProvider(),
			}
		}
	},
	computed: {
		...mapState('customerList', ['responseError']),
		center() {
			return latLng(this.location.lat, this.location.lng)
		},
		position() {
			return latLng(this.location.lat, this.location.lng)
		},
		storePosition() {
			return latLng(this.storeLocation.lat, this.storeLocation.lng)
		},
	},
	methods: {
		...mapActions('customerList', ['getOptionProvince', 'getOptionCity', 'getOptionSubdistrict']),
		// ...mapActions('maps', ['getMaps', 'getGeolocation']),
		// ...mapMutations('maps', ['setLocation']),

		async onResize() {
			await this.$refs.myMap.mapObject._onResize();
			// Access the Leaflet map instance
			const map = await this.$refs.myMap.mapObject;

			// Listen for the 'geosearch/showlocation' event on the map instance
			await map.on('geosearch/showlocation', this.handleGeosearchResult);
		},
		updateLocation(event) {
			const latLng = event.target.getLatLng();
			this.location.lat = latLng.lat;
			this.location.lng = latLng.lng;

			this.formLocation.lat = latLng.lat;
			this.formLocation.lng = latLng.lng;
		},
		updateLat(val) {
			this.location.lat = parseFloat(val)
			this.fomrLocation.lat = parseFloat(val)
		},
		updateLng(val) {
			this.location.lng = parseFloat(val)
			this.formLocation.lng = parseFloat(val)
		},
		updateCoordinates(location) {
			this.setLocation({
				lat: location.latLng.lat(),
				lng: location.latLng.lng()
			})
		},
		async cekMaps() {
			let district = this.subdistricts.find(el => el.subdistrict_id == this.kecamatan)
			// this.getMaps((this.address ? this.address + ', ' : '') + district.subdistrict_name + ', ' + district.city_name + ', ' + district.province)
			let searchQuery = district.subdistrict_name + ', ' + district.city_name + ', ' + district.province
			const results = await this.geosearchOptions.provider.search({ query: searchQuery });
			if (results && results.length > 0) {
				this.updateLocationSearch(results[0].y, results[0].x);
			}
		},
		async getCity() {
			this.kota = await '';
			this.kecamatan = await '';
			this.cities = await this.getOptionCity(this.provinsi)
		},
		async getSubdistrict() {
			this.kecamatan = await '';
			this.subdistricts = await this.getOptionSubdistrict(this.kota)
		},
		async showModal(data) {
			this.detailCustomer = data;
			this.provinces = await this.getOptionProvince()
			if (this.detailCustomer.customer_province_id && this.detailCustomer.customer_province_id > 0)
				this.cities = await this.getOptionCity(this.detailCustomer.customer_province_id)
			if (this.detailCustomer.customer_city_id && this.detailCustomer.customer_city_id > 0)
				this.subdistricts = await this.getOptionSubdistrict(this.detailCustomer.customer_city_id)
			this.provinsi = await this.detailCustomer.customer_province_id
			this.kota = await this.detailCustomer.customer_city_id
			this.kecamatan = await this.detailCustomer.customer_subdistrict_id
			this.address = await this.detailCustomer.customer_address
			if(this.detailCustomer.customer_latitude && this.detailCustomer.customer_longitude){
				this.formLocation.lat = this.detailCustomer.customer_latitude
				this.formLocation.lng = this.detailCustomer.customer_longitude
			} else {
				this.formLocation.lat = ''
				this.formLocation.lng = ''
			}
			this.storeLocation = await {
				lat: parseFloat(this.detailCustomer.customer_latitude) || 0,
				lng: parseFloat(this.detailCustomer.customer_longitude) || 0
			}
			this.location = await {
				lat: parseFloat(this.detailCustomer.customer_latitude) || -6.195590285033856,
				lng: parseFloat(this.detailCustomer.customer_longitude) || 106.8240061190492
			}
			this.dialog = await true
		},
		hideModal() {
			this.dialog = false
		},
		batal() {
			this.hideModal()
		},
		simpan() {
			if (this.$refs.formAddress.validate()) {
				let subdistrict = this.subdistricts.find(el => el.subdistrict_id == this.kecamatan)
				let params = {
					id: this.detailCustomer.customer_id,
					network_id: this.detailCustomer.customer_network_id,
					network_mid: this.detailCustomer.customer_network_mid,
					network_code: this.detailCustomer.customer_network_code,
					name: this.detailCustomer.customer_name,
					email: this.detailCustomer.customer_email,
					mobilephone: this.detailCustomer.customer_mobilephone,
					mobilephone2: this.detailCustomer.customer_mobilephone2,
					province_id: subdistrict.province_id,
					province_name: subdistrict.province,
					city_id: subdistrict.city_id,
					city_name: subdistrict.city_name,
					subdistrict_id: subdistrict.subdistrict_id,
					subdistrict_name: subdistrict.subdistrict_name,
					address: this.address,
					latitude: this.location.lat,
					longitude: this.location.lng,
					level: this.detailCustomer.customer_level,
					trx_method: this.detailCustomer.customer_trx_method,
					trx_ecommerce: this.detailCustomer.customer_trx_ecommerce
				}
				this.$emit('action', params)
			}
		},
		handleGeosearchResult(event) {
			this.updateLocationSearch(event.location.y, event.location.x);
		},
		updateLocationSearch(lat, lng) {
			this.zoom = 16;
			this.location.lat = lat;
			this.location.lng = lng;

			this.formLocation.lat = lat;
			this.formLocation.lng = lng;
		},
	},
	unmounted() {
		const map = this.$refs.map.mapObject;
		if (map) {
			map.off('geosearch/showlocation', this.handleLocationSelected);
		}
	},
}
</script>
